// extracted by mini-css-extract-plugin
export default {"cardTitle":"cardTitle_cardTitle__iVCNl"};